// removed by extract-text-webpack-plugin
module.exports = {"trendsTable":"trends_trendsTable_nliqf","renderItem":"trends_renderItem_SY5SR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/riskHint/trends.scss
// module id = 1568
// module chunks = 0